<template>
	<div :class="['c-transcript-view', { accordion: isAccordion === true }]">
		<div :class="['c-transcript-view__wrap', { expanded: expanded === true }]">
			<div
				:class="[
					'c-transcript-view__row',
					{ oldstyle: oldStyledTranscript === true },
				]"
				v-for="(text, i) in texts"
				:key="i"
			>
				<section v-if="!oldStyledTranscript">
					<span>{{ toSeconds(text.start) }}</span>
					<span>-</span>
					<span>{{ toSeconds(text.end) }}</span>
				</section>
				<article>
					{{ text.text || text }}
				</article>
			</div>
			<div class="c-transcript-view__buttons">
				<button
					type="button"
					class="btn btn-box btn-icon btn-sm"
					@click.prevent="onCopy"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 15V18.75C15 19.9926 13.9926 21 12.75 21H5.25C4.00736 21 3 19.9926 3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H9M11.25 15H18.75C19.9926 15 21 13.9926 21 12.75V5.25C21 4.00736 19.9926 3 18.75 3H11.25C10.0074 3 9 4.00736 9 5.25V12.75C9 13.9926 10.0074 15 11.25 15Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Copy Transcript </span>
				</button>
				<button
					v-if="!oldStyledTranscript"
					type="button"
					class="btn btn-box btn-icon btn-sm"
					@click.prevent="onCopyWithTimestamps"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 15V18.75C15 19.9926 13.9926 21 12.75 21H5.25C4.00736 21 3 19.9926 3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H9M11.25 15H18.75C19.9926 15 21 13.9926 21 12.75V5.25C21 4.00736 19.9926 3 18.75 3H11.25C10.0074 3 9 4.00736 9 5.25V12.75C9 13.9926 10.0074 15 11.25 15Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Copy Transcript with timestamps </span>
				</button>
			</div>
		</div>
		<div
			:class="['c-transcript-view__expand', { expanded: expanded === true }]"
		>
			<span class="btn" @click="expand"> {{ expandText }} </span>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			expanded: false,
		};
	},

	props: {
		texts: {},
	},

	computed: {
		isAccordion: function () {
			let texts = this.texts;

			if (texts && texts.length > 3) {
				return true;
			}
		},
		expandText: function () {
			if (this.expanded) {
				return `Hide transcript`;
			}
			return `View full transcript`;
		},
		oldStyledTranscript: function () {
			if (!this.texts) {
				return;
			}

			let texts = this.texts;

			let text = texts[0];

			if (typeof text === 'string') {
				return true;
			}
		},
	},

	methods: {
		expand: function () {
			this.expanded = !this.expanded;
		},
		toSeconds: function (milliseconds) {
			// Calculate minutes and seconds
			const minutes = Math.floor(milliseconds / 60000); // 60000 milliseconds in a minute
			const seconds = Math.floor((milliseconds % 60000) / 1000); // remaining seconds

			// Format minutes and seconds to always be two digits
			const formattedMinutes = minutes.toString().padStart(2, '0');
			const formattedSeconds = seconds.toString().padStart(2, '0');

			return `${formattedMinutes}:${formattedSeconds}`;
		},
		onCopy: function () {
			let texts = this.texts;
			let text = '';
			if (this.oldStyledTranscript) {
				for (let i = 0; i < texts.length; i++) {
					let txt = texts[i];
					text += `${txt}\r\n`;
				}
			} else {
				for (let i = 0; i < texts.length; i++) {
					let txt = texts[i];
					text += `${txt.text}\n`;
				}
			}

			navigator.clipboard.writeText(text);

			const message = {
				message: `Transcript copied`,
				status: 'success',
			};

			this.$store.dispatch('message/sendMessage', message);
		},
		onCopyWithTimestamps: function () {
			let texts = this.texts;
			let text = '';
			for (let i = 0; i < texts.length; i++) {
				let txt = texts[i];
				text += `${this.toSeconds(txt.start)}-${this.toSeconds(txt.end)}\r\n${
					txt.text
				}\r\n\r\n`;
			}

			navigator.clipboard.writeText(text);

			const message = {
				message: `Transcript copied`,
				status: 'success',
			};

			this.$store.dispatch('message/sendMessage', message);
		},
	},
};
</script>

<style lang="scss">
.c-transcript-view {
	&.accordion {
		.c-transcript-view__wrap {
			max-height: 180px;

			&:after {
				display: block;
			}
		}

		.c-transcript-view__expand {
			display: flex;
		}
	}

	&__wrap {
		position: relative;
		overflow: hidden;
		padding-bottom: var(--margin);

		transition: all var(--transition-time) ease-out;

		&:after {
			content: '';
			display: none;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 60px;
			background: linear-gradient(
				0deg,
				rgba(255, 255, 255, 1) 0%,
				rgba(255, 255, 255, 0) 100%
			);
			pointer-events: none;
			transition: all var(--transition-time) ease-out;
		}

		&.expanded {
			max-height: initial !important;

			&:after {
				opacity: 0;
			}
		}
	}

	&__expand {
		width: 100%;
		display: none;
		align-items: center;
		justify-content: center;
		border-top: var(--color-bg-4) solid 1px;
		transition: all var(--transition-time) ease-out;

		.btn {
			transform: translateY(-50%);
			font-weight: 500;
			transition: all var(--transition-time) ease-out;
		}

		&.expanded {
			border-top-color: transparent;

			.btn {
				transform: translateY(0);
			}
		}
	}

	&__row {
		display: grid;
		grid-template-columns: 104px 1fr;
		grid-column-gap: var(--margin-lg);
		font-family: var(--font-family-monospace);
		font-size: var(--font-size-sm);

		span {
			color: var(--color-secondary);
		}

		article {
		}

		&:not(:last-child) {
			margin-bottom: var(--margin-lg);
		}

		&.oldstyle {
			grid-template-columns: 1fr;
		}
	}

	&__buttons {
		display: flex;
		align-items: center;
		padding: var(--margin-sm) var(--margin);

		button {
			font-size: var(--font-size-xs);
			&:not(:last-child) {
				margin-right: var(--margin);
			}
		}
	}
}
</style>
